import { useContext } from "react"
import { ModalsContext } from "web/contexts"

export default function useModals() {
  const { modals, setModals, lastModalKey } = useContext(ModalsContext)

  function exists(type) {
    if (type === null) return false
    return modals.findIndex((el) => el.type === type) !== -1
  }

  function create(props) {
    const { autoClearInterval = null, type = null, ...restOfProps } = props

    if (exists(type)) return

    const key = lastModalKey.current
    lastModalKey.current++

    const instancePromise = {}

    const promise = new Promise((resolve, reject) => {
      instancePromise.resolve = resolve
      instancePromise.reject = reject
    })

    setModals([...modals, { key, type, instancePromise, ...restOfProps }])

    if (autoClearInterval) {
      setTimeout(() => {
        clear(key)
      }, autoClearInterval)
    }

    return promise
  }

  function clear(key) {
    const newModals = [...modals]
    const index = newModals.findIndex((el) => el.key === key)

    if (index !== -1) {
      newModals.splice(index, 1)
      setModals(newModals)
    }
  }

  return { modals, showModal: create, clearModal: clear }
}
